// extracted by mini-css-extract-plugin
module.exports = {"cards-container":"CardsContainer_cards-container__5cCKM","card":"CardsContainer_card__LJax_"};